import { render, staticRenderFns } from "./CardNav.vue?vue&type=template&id=f62ace5e&scoped=true&"
import script from "./CardNav.vue?vue&type=script&lang=js&"
export * from "./CardNav.vue?vue&type=script&lang=js&"
import style0 from "./CardNav.vue?vue&type=style&index=0&id=f62ace5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62ace5e",
  null
  
)

export default component.exports